export const blobUrlToFile = (blobUrl,fileName) => new Promise((resolve) => {
  fetch(blobUrl).then((res) => {
    res.blob().then((blob) => {
      // please change the file.extension with something more meaningful
      // or create a utility function to parse from URL
      const file = new File([blob], fileName, {type: blob.type})
      resolve(file)
    })
  })
})